const languageToIcon = {
    java: 'languageIcon-java',
    javascript: 'languageIcon-js',
    angular: 'languageIcon-angular',
    python: 'languageIcon-pydj',
    csharp: 'languageIcon-csharp',
    php: 'languageIcon-php',
    go: 'languageIcon-go',
    perl: 'languageIcon-perl',
    nodejs: 'languageIcon-nodeJs',
    ios: 'languageIcon-ios',
    android: 'languageIcon-android',
    dotnet: 'languageIcon-net',
    scala: 'languageIcon-scala',
    cplus: 'languageIcon-cplus',
    react: 'languageIcon-react'
};

const getIconByTags = (tags: string[]) => {
    const tag = tags.find(tag => languageToIcon[tag]);
    return tag ? languageToIcon[tag] : undefined;
};

export default getIconByTags;
